module.exports = {
	"Search the video": "Durchsuche das Video",
	"Explore": "Mehr entdecken",
	"Print": "Drucken",
	"Download": "Herunterladen",
	"Share": "Teilen",
	"Settings": "Optionen",
	"Language": "Sprache",
	"Interface Language": "Bedienungssprache",
	"Transcript / Captions Language": "Sprache der Untertitel/des Transkripts",
	"Transcript Language": "Sprache des Transkripts",
	"Captions Language": "Sprache der Untertitel",
	"Show Transcript": "Transkript anzeigen",
	"Show Captions": "Untertitel anzeigen",
	"Show Heatmap": "Heatmap anzeigen",
	"Show Speakers in Transcript": "Sprechernamen im Transkript anzeigen",
	"Keyword": "Schlagwort",
	"Keywords": "Schlagworte",
	"Topic": "Thema",
	"Topics": "Themen",
	"Speaker": "Sprecher",
	"Speakers": "Sprecher",
	"Transcript": "Transkript",
	"Previous": "Vorheriges Ergebnis",
	"Next": "Nächstes Ergebnis",
	"Clear": "Löschen",
	"No results found": "Keine Suchergebnisse gefunden",
	"try another search or explore": "versuche es mit einem anderen Begriff oder klicke auf Mehr entdecken",
	"Share Search": "Teile meine Suchergebnisse",
	"Share Time": "Teile diesen Zeitpunkt im Video.",
	"There is no transcript available in the selected language.": "Kein Transkript verfügbar in dieser Sprache",
	"Show {{count}} more": "Zeige 1 weiteres Surchergebnis.",
	"Show {{count}} more_plural": "Zeige {{count}} weitere Suchergebnisse."
};


//////////////////
// WEBPACK FOOTER
// ./locale/de.json
// module id = ./locale/de.json
// module chunks = 0 1